import { useQuery } from '@tanstack/react-query';
import buyerServiceV3 from '../services/v3/buyer.service';

export const useGetBuyers = () => {
  return useQuery({
    queryKey: ['buyers', 'Buyer'],
    queryFn: () => buyerServiceV3.fetchOrganizations('Buyer'),
  });
};

export const useGetConveners = () => {
  return useQuery({
    queryKey: ['buyers', 'Convener'],
    queryFn: () => buyerServiceV3.fetchOrganizations('Convener'),
  });
};

export const useGetConsortiums = () => {
  return useQuery({
    queryKey: ['buyers', 'Consortium'],
    queryFn: () => buyerServiceV3.fetchOrganizations('Consortium'),
  });
};
